import { Type } from "class-transformer";
import { FrontendField } from "src/modules/sm-base/netgen/FrontendField";

export class AnonymousSearchConfig {
    @Type(() => FrontendField)
    formFields: FrontendField[];
    caption = "";
    anonymousOnly = true;
}
